import { Component, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { CommonFunctions } from '../../shared/static/common-functions';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { InvoicePaymentBus } from '@app/cp/shared/models/InvoicePaymentBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'invoice-payments',
    templateUrl: './invoice-payments.component.html',
    styleUrls: ['./invoice-payments.component.scss']
})
export class InvoicePaymentsComponent extends BaseGridEditLineComponent<InvoicePaymentBus, null, InvoiceService> implements OnDestroy  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "InvoicePaymentBus";
        this.saveMode = SaveMode.individual;
        this.appCode = "InvoicePayments";
        this.callSaveIndividualInsteadOfSave = true;
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'invoicePaymentId': new UntypedFormControl(),
            'invoiceId': new UntypedFormControl(),
            'amountReceived': new UntypedFormControl('', Validators.required),
            'paymentMethodId': new UntypedFormControl('', Validators.required),
            'refNumber': new UntypedFormControl('', Validators.required),
            'memo': new UntypedFormControl(),
            'receivedById': new UntypedFormControl('', Validators.required),
            'dateReceived': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'qbid': new UntypedFormControl(),
            'qbeditSequenceId': new UntypedFormControl(),
            'isBulk': new UntypedFormControl(),
        });

    }
    setForm() {
        this.editForm.patchValue({
            invoicePaymentId: this.selectedData.invoicePaymentId,
            invoiceId: this.selectedData.invoiceId,
            amountReceived: this.selectedData.amountReceived,
            paymentMethodId: this.selectedData.paymentMethodId,
            refNumber: this.selectedData.refNumber,
            memo: this.selectedData.memo,
            receivedById: this.selectedData.receivedById,
            dateReceived: this.selectedData.dateReceived,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            isBulk: this.selectedData.isBulk,
            qbid: this.selectedData.qbid,
            qbeditSequenceId: this.selectedData.qbeditSequenceId
        });
    }
    clear() {
        super.clear();
        this.notificationChecked = false;
        this.dataWasChanged = false;
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_data);
    }
    dataWasChanged: boolean = false;
    subs_data: Subscription;
    public setup(data: string) {
        this.clear();
        this.subs_data = this.svc_data.getInvoicePayments(data).subscribe((info: BaseMessageInfo) => {
            if (info != null) {
                this.gridData = this.getGridData(info.primaryReturn);
                this.cloneData();
            }
            else {
                this.gridData = null;
            }
        });
    }
    test() {
    }
    notificationChecked: boolean = false;
    cancelEvent() {
        this.cancelHandler();
        this.gridData = null;
        this.close(false);
    }
    closeEvent() {
        this.gridData = null;
        this.close(this.dataWasChanged);
    }
    getChangedObject(data: InvoicePaymentBus) {
        let busObj: InvoicePaymentBus = new InvoicePaymentBus(data);
        busObj.isConstruction = this.isConstruction;
        busObj.notificationChecked = this.notificationChecked;
        busObj.setBeforeSave();
        return busObj;
    }
    saveIndividual(data: InvoicePaymentBus): Promise<BaseMessageInfo> {
        this.dataLoading = true;
        let busObj: InvoicePaymentBus = this.getChangedObject(data); // new v_DispatchAttachmentBus(data);
        //busObj.setParentId(this._parentId);
        //busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        ////  data.referenceId = this._parentId;
        console.log("inv-paym->save: ", busObj);
//        return;
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveInvoicePayment(busObj).toPromise().then((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.dataWasChanged = true;
                    busObj = new InvoicePaymentBus(info.primaryReturn);
                    retInfo.primaryReturn = busObj;

                    //this.refreshMessage.emit(null);
                    //this.saveLocal(newBusObj, false);
                    this.notify(this.appCode + " Saved Successfully!");
                }
                else {
                    retInfo.message = info.message;
                    retInfo.saveError = true;
                    this.saveError(info.primaryReturn as InvoicePaymentBus, info.message);
                }
                this.dataLoading = false;
                resolve(retInfo);
            });
        });
    }
    deleteIndividual(data: InvoicePaymentBus) {
        if (data.hasId) {
            this.svc_data.deleteInvoicePayment(data.CID()).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.dataWasChanged = true;
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    //saveEvent() {
    //    let dataObjs: InvoicePaymentBus[] = this.getChanged();
    //    let deletedObjs: GItem[] = this.getDeletedItems();
    //    for (let i = 0; i < deletedObjs.length; i++) {
    //        let dataObj = this.originalData.find(s => s.CID() === deletedObjs[i].value);
    //        let busObj = this.getChangedObject(dataObj);
    //        busObj.isUpdated = true;
    //        busObj.setBeforeSave();
    //        dataObjs.push(busObj);
    //    }

    //    //this.svc_data.saveScheduledInvoices(dataObjs).subscribe((info: BaseMessageInfo) => {
    //    //    if (!info.saveError) {

    //    //        this.saveSuccess(null);
    //    //        this.close(true);
    //    //    }
    //    //    else {
    //    //        this.saveError(null, info.message);
    //    //    }
    //    //});
    //}
    dataChanged: boolean = false;
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        if (type === MessageType.changed) {
            this.dataChanged = true;
        }
        super.sendParentMessage(type, subject, message, values, value)
    }
    close(e: any) {
        this.dataChanged = false;
        super.close(e);
    }

}
